
import param from '~/utils/url/param.js'
export default {
  name: 'social-facebook',
  props: {
    url: {
      type: String,
      async default() {
        return await this.$route.name
      }
    }
  },
  methods: {
    open() {
      window.open(
        'https://www.facebook.com/sharer/sharer.php' + param({ u: this.url }),
        '__blank'
      )
    }
  }
}
